import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  AxiosPaymentInstance,
  AxiosPropertyInstance,
} from "../../../common/utils/AxiosInstance";

export const getAllServices = createAsyncThunk(
  "getAllServices",
  async (_, { rejectWithValue }) => {
    const URL = `/static/services/index.json`;
    try {
      const res = await AxiosPropertyInstance.get(URL);
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getServiceById = createAsyncThunk(
  "getServiceById",
  async (id, { rejectWithValue }) => {
    const URL = `/static/services/${id}/index.json`;
    try {
      const res = await AxiosPropertyInstance.get(URL);
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getServicesFillDetailsData = createAsyncThunk(
  "getServicesFillDetailsData",
  async (id, { rejectWithValue }) => {
    const URL = `/static/services/${id}/form/index.json`;
    try {
      const res = await AxiosPropertyInstance.get(URL);
      // Overlay live DB add-on prices (checkbox prices + baseprice) onto the
      // static form so the displayed amount matches what checkout charges. The
      // form STRUCTURE (labels, fields, radios) stays from JSON; only the price
      // numbers are replaced, and only when the DB has an override for this
      // service — otherwise the static values remain.
      try {
        const dbRes = await AxiosPropertyInstance.get(
          "/service-pricing/singleton/propertyService"
        );
        const dbItem = (dbRes?.data?.services || []).find((s) => s?.id === id);
        if (dbItem && res?.data) {
          if (
            Array.isArray(res.data.checkboxes) &&
            Array.isArray(dbItem.checkboxes)
          ) {
            res.data.checkboxes = res.data.checkboxes.map((cb) => {
              const dbCb = dbItem.checkboxes.find((x) => x?.id === cb?.id);
              return dbCb && dbCb.price != null
                ? { ...cb, price: dbCb.price }
                : cb;
            });
          }
          if (Array.isArray(dbItem.baseprice) && dbItem.baseprice.length) {
            res.data.baseprice = dbItem.baseprice;
          }
        }
      } catch {
        /* keep static form prices */
      }
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const submitServiceFillDetails = createAsyncThunk(
  "submitServiceFillDetails",
  async ({ data, serviceType }, { rejectWithValue }) => {
    const URL = `/v1/customer/checkout/type/${serviceType}`;
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const res = await AxiosPaymentInstance.post(URL, data, {
        headers: { "x-auth-token": token },
      });
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      const returnedError = {
        status: error?.response?.status,
        error: error?.response?.data,
      };

      return rejectWithValue(JSON.parse(JSON.stringify({ ...returnedError })));
    }
  }
);

// service Review Actions
export const submitServiceReview = createAsyncThunk(
  "submitServiceReview",
  async (data, { rejectWithValue }) => {
    const path = `/ratings`;
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const res = await AxiosPropertyInstance.post(path, data, {
        headers: {
          "x-auth-token": token,
        },
      });
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getServiceReviews = createAsyncThunk(
  "getServiceReviews",
  async (data, { rejectWithValue }) => {
    const path = `/ratings/public/PROPERTY_SERVICE/${data?.serviceType}/${data?.documentType}/ratings`;
    try {
      const res = await AxiosPropertyInstance.get(path);
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getCustomerServiceReviews = createAsyncThunk(
  "getCustomerServiceReviews",
  async (data, { rejectWithValue }) => {
    const path = `/ratings/public/PROPERTY_SERVICE/${data?.serviceType}/${data?.documentType}/reviews?pageSize=${data?.pageSize}&pageIndex=${data?.pageIndex}`;
    try {
      const res = await AxiosPropertyInstance.post(path, data);
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const getAllServiceReviews = createAsyncThunk(
  "getAllServiceReviews",
  async (data, { rejectWithValue }) => {
    const path = `/ratings/public/PROPERTY_SERVICE/peoplesRatings`;
    try {
      const res = await AxiosPropertyInstance.get(path);
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const servicesDocUpload = createAsyncThunk(
  "servicesDocUpload",
  async (data, { rejectWithValue }) => {
    const path = `/form/file`;
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const res = await AxiosPropertyInstance.post(path, data, {
        headers: {
          "x-auth-token": token,
        },
      });
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const servicesDocDelete = createAsyncThunk(
  "servicesDocDelete",
  async ({ id, data }, { rejectWithValue }) => {
    const path = `/form/file`;
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const res = await AxiosPropertyInstance.delete(path, {
        headers: {
          "x-auth-token": token,
        },
        data,
      });
      return { id: id, response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);

export const servicesGetPropertyCategories = createAsyncThunk(
  "servicesGetPropertyCategories",
  async (propertType, { rejectWithValue }) => {
    const path = `/static/services/${propertType}/index.json`;
    try {
      const res = await AxiosPropertyInstance.get(path);
      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      return rejectWithValue(JSON.parse(JSON.stringify(error)));
    }
  }
);
